import React, { useState } from 'react';
import { Image } from 'antd';
import { useCookies } from 'react-cookie';
import { useProjectDropList } from 'hooks/queries/common/commonDropListQuery';
import useCurrencyTypeDropQuery from 'hooks/queries/common/useCurrencyTypeDropQuery';
import { checkState } from 'utils/constant';
import DefaultLayout from 'components/layout/DefaultLayout';
import TableToolbar from 'components/table/TableToolbar';
import MainTable from 'components/table/MainTable';
import NoImage from 'components/etc/NoImage';
import CapsuleButton from 'components/button/CapsuleButton';
import CheckboxOneType from 'components/input/CheckboxOneType';
import DefaultButton from 'components/button/DefaultButton';
import DefaultInput from 'components/input/DefaultInput';
import DefaultSelect from 'components/select/DefaultSelect';
import { useCurrencyList } from 'hooks/queries/platform/currencyQuery';
import { useNavigate } from 'react-router-dom';
import TextButton from 'components/button/TextButton';
import { useTranslation } from 'react-i18next';
/**
 * * 플랫폼 관리 - 재화 목록
 */

const CurrencyListPage = () => {
  const { t } = useTranslation();
  const [{ platformAuth = 'false' }] = useCookies();
  const navigate = useNavigate();

  const { data: projectDropList } = useProjectDropList();
  const { data: currencyTypeDropList } = useCurrencyTypeDropQuery();

  const [searchData, setSearchData] = useState({
    search_name: '',
    search_project: '',
    search_type: '',
  });
  const { data: currencyList } = useCurrencyList(searchData);

  const handleSearchChange = (e) => {
    const { name, value } = e.target;
    setSearchData({ ...searchData, [name]: value });
  };

  /// 검색 드롭다운. 다중 선택 가능(TODO!)
  const handleSearchSelect = (val, option) => {
    setSearchData({ ...searchData, [option.name]: val });
  };

  /// 검색 초기화
  const handleResetClick = (e) => {
    setSearchData({
      ...searchData,
      search_name: '',
      search_project: '',
      search_type: '',
    });
  };

  const handleLink = (record) => () => {
    navigate(`/currencyMaster/${record.currency}`);
  };

  const columnsOrigin = [
    {
      title: t('currencyMaster.table.tableHeader.icon'),
      dataIndex: 'icon_image_url',
      width: '4rem',
      render: (text, record, index) => (
        <>
          {record.icon_image_url === '' || record.icon_image_url === null ? (
            <NoImage />
          ) : (
            <Image
              src={record.icon_image_url}
              alt={`icon`}
              height={60}
              style={{
                objectFit: 'contain',
              }}
            />
          )}
        </>
      ),
    },
    {
      title: t('currencyMaster.table.tableHeader.resource'),
      dataIndex: 'resource_image_url',
      width: '4.5rem',
      render: (text, record, index) => (
        <>
          {record.resource_image_url === '' ||
          record.resource_image_url === null ? (
            <NoImage />
          ) : (
            <Image
              src={record.resource_image_url}
              alt='resource'
              height={60}
              style={{
                objectFit: 'contain',
              }}
            />
          )}
        </>
      ),
    },
    {
      title: t('currencyMaster.table.tableHeader.currencyID'),
      dataIndex: 'currency',
      width: '3rem',
      sorter: (a, b) => a.currency.localeCompare(b.currency),
    },
    {
      title: t('currencyMaster.table.tableHeader.currencyName'),
      width: '8rem',
      dataIndex: 'origin_name',
      render: (text, record, index) => (
        <TextButton>
          {record.KO === null ? record.origin_name : record.KO}
        </TextButton>
      ),
      sorter: (a, b) => a.origin_name.localeCompare(b.origin_name),
    },
    {
      title: t('currencyMaster.table.tableHeader.internalCurrencyName'),
      dataIndex: 'dev_name',
      width: '8rem',
      sorter: (a, b) => a.origin_name.localeCompare(b.origin_name),
      render: (text, record) => (
        <TextButton onClick={handleLink(record)}>{text}</TextButton>
      ),
    },
    {
      title: t('currencyMaster.table.tableHeader.currencyType'),
      dataIndex: 'currency_type_name',
      width: '4rem',
      filters: currencyTypeDropList,
      onFilter: (value, record) => record.currency_type.indexOf(value) === 0,
    },
    {
      title: t('currencyMaster.table.tableHeader.linkedStory'),
      width: '7rem',
      dataIndex: 'connected_project',
      render: (text, record, index) =>
        projectDropList?.map(
          (v) => v.value === record.connected_project && <span>{v.text}</span>,
        ),
      // filters: projectDropList,
      // indexOf(value) 값이 있으면 true=0
      // onFilter: (value, record) => record.connected_project === value,
      // sorter: (a, b) => a.connected_project.localeCompare(b.connected_project),
    },
    {
      title: t('currencyMaster.table.tableHeader.coinProductCurrency'),
      dataIndex: 'is_coin',
      key: 'is_coin',
      width: '3rem',
      filters: checkState,
      onFilter: (value, record) => record?.is_coin === value,
      render: (text, record, index) =>
        record.is_coin === 1 && <CheckboxOneType disabled checked={true} />,
    },
    {
      title: t('currencyMaster.table.tableHeader.missionReward'),
      dataIndex: 'mission_reward',
      width: '3rem',
      filters: checkState,
      render: (text, record, index) =>
        record.mission_reward === 1 && (
          <CheckboxOneType disabled checked={true} />
        ),
      onFilter: (value, record) => record?.mission_reward === value,
    },
    {
      title: t('currencyMaster.table.tableHeader.usageStatus'),
      dataIndex: 'is_use',
      width: '3rem',
      filters: checkState,
      onFilter: (value, record) => record?.mission_reward === value,
      render: (text, record, index) =>
        record.is_use === 1 && <CheckboxOneType disabled checked={true} />,
    },
    {
      title: t('currencyMaster.table.tableHeader.consumable'),
      dataIndex: 'consumable',
      width: '3rem',
      filters: checkState,
      onFilter: (value, record) => record?.consumable === value,
      render: (text, record, index) =>
        record.consumable === 1 && <CheckboxOneType disabled checked={true} />,
    },
    {
      title: t('currencyMaster.table.tableHeader.uniqueness'),
      dataIndex: 'is_unique',
      width: '3rem',
      filters: checkState,
      onFilter: (value, record) => record?.is_unique === value,
      render: (text, record, index) =>
        record.is_unique === 1 && <CheckboxOneType disabled checked={true} />,
    },
    {
      title: t('currencyMaster.table.tableHeader.stats'),
      dataIndex: 'is_ability',
      width: '3rem',
      filters: checkState,
      onFilter: (value, record) => record?.is_ability === value,
      render: (text, record, index) =>
        record.is_ability === 1 && <CheckboxOneType disabled checked={true} />,
    },
    {
      title: t('currencyMaster.table.tableHeader.action'),
      width: '4rem',
      render: (text, record, index) => {
        return (
          <CapsuleButton name='update' onClick={handleLink(record)}>
            {t('currencyMaster.table.tableContent.edit')}
          </CapsuleButton>
        );
      },
    },
  ];

  return (
    <>
      <DefaultLayout>
        <TableToolbar>
          <div className='wrap' style={{ alignItems: 'center' }}>
            <DefaultInput
              title={t('currencyMaster.headerSelect.searchInput')}
              name='search_name'
              value={searchData.search_name}
              onChange={handleSearchChange}
              style={{ width: '100%', marginRight: '0.3rem' }}
            />
            <DefaultSelect
              title={t('currencyMaster.headerSelect.storySelect')}
              name='search_project'
              value={searchData.search_project}
              optionList={projectDropList}
              onChange={handleSearchSelect}
              style={{ width: '100%', marginRight: '0.6rem' }}
            />
            <DefaultSelect
              title={t('currencyMaster.headerSelect.currencyTypeSelect')}
              name='search_type'
              value={searchData.search_type}
              optionList={currencyTypeDropList}
              onChange={handleSearchSelect}
              style={{ width: '100%' }}
            />

            <DefaultButton
              onClick={handleResetClick}
              style={{ width: '12rem', height: '3rem' }}
              typename='sub'
            >
              {t('currencyMaster.headerSelect.resetButton')}
            </DefaultButton>
          </div>
          <DefaultButton
            disabled={JSON.parse(platformAuth)}
            onClick={handleLink({ currency: '0' })}
          >
            {t('currencyMaster.headerSelect.registrationButton')}
          </DefaultButton>
        </TableToolbar>
        <MainTable columns={columnsOrigin} dataSource={currencyList} />
      </DefaultLayout>
    </>
  );
};
export default CurrencyListPage;
